import React from 'react';
import Badge from '@atlaskit/badge';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { BREACH_COLOR, MEET_COLOR, QUALITY_ISSUE_COLOR } from '@/styles';

interface BreachCountProps {
  count?: number;
  isWarning?: boolean;
}

const meetAppearance = { backgroundColor: MEET_COLOR, color: token('color.text.inverse', 'white') };

const BreachCount: React.FC<BreachCountProps> = ({ count, isWarning }) => {
  const appearance = count
    ? {
        color: token('color.text.inverse', 'white'),
        backgroundColor: isWarning ? QUALITY_ISSUE_COLOR : BREACH_COLOR,
      }
    : meetAppearance;
  return (
    <div
      css={css`
        text-align: center;
        span {
          ${count ? 'font-weight: 500;' : ''}
        }
      `}
    >
      <Badge style={appearance} max={Infinity}>
        {count}
      </Badge>
    </div>
  );
};

export default BreachCount;
